module.exports = __webpack_public_path__ + "static/media/picky_flyer_sm.25ee60e7.png";